<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <form class="text-edit-dialog-form">
    <mat-form-field style="width: 100%">
      <mat-label>{{ data.prompt }}</mat-label>
      <textarea
        matInput
        cdkTextareaAutosize
        cdkAutosizeMinRows="10"
        cdkAutosizeMaxRows="50"
        name="CurrentData"
        [(ngModel)]="CurrentData"
        style="width: 100%"
      ></textarea></mat-form-field
    ><br />
  </form>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    class="piButton"
    (click)="onConfirmClick()"
    cdkFocusInitial
  >
    Confirm
  </button>
  <button mat-raised-button class="piButton" (click)="onCancelClick()">
    Cancel
  </button>
</div>
